<template>
  <div class="container">
    <div class="jumbotron">
      <div style="flex: 1">
        <div class="title">
          <h1 class="company-title">
            Rent Application
          </h1>
          <h1 style="font-weight: normal">
            Employment Verification
          </h1>
        </div>
        <div class="device-container-mobile">
          <img src="@/assets/device.png" />
        </div>
        <div v-if="!isApplicantLoading && getApplicantVerification" class="cta">
          <p>
            Hi {{ getApplicantVerification.request_data.applicant_first_name }},
            <br />Let’s get started verifying your income and employment. This
            will only take a few minutes.
          </p>

          <div class="button-container">
            <router-link tag="a" :to="{ name: 'verify-applicant-email' }"
              >Get Started <img src="@/assets/arrow.svg"
            /></router-link>
          </div>
        </div>
      </div>

      <div class="device-container">
        <img src="@/assets/device.png" />
      </div>
    </div>
    <div class="line"></div>

    <div class="who" style="padding: 10px 5vw;">
      <div class="logo-container" style="display: flex;">
        <div>
          <img src="@/assets/logo.png" style="width: 58px; height: 58px;" />
        </div>
        <div style="margin-left: 20px;">
          <h2>
            Who is Rent Application?
          </h2>
        </div>
      </div>
      <div>
        <p>
          Rent Application, a participating member of the National Consumer
          Reporting Association, is an online tenant screening platform that has
          been serving more than 40,000 landlords and real estate professionals
          nationwide since 2013. Rent Application is trusted by the real estate
          industry’s biggest names:
        </p>
      </div>
    </div>
    <div class="logo-banner-container">
      <img style="width: 100%;" src="@/assets/logo-banner.png" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  mounted() {},
  computed: {
    ...mapGetters(["getApplicantVerification", "isApplicantLoading"])
  }
};
</script>
<style lang="scss" scoped>
.jumbotron {
  height: 500px;
  padding: 20px;
  background: linear-gradient(165deg, transparent 50%, #fff 50.1%),
    linear-gradient(to bottom, #3659c0, #3659c0);
  display: flex;
  flex-direction: row;

  .device-container-mobile {
    display: none;
  }

  .title {
    margin-top: 60px;
    h1 {
      font-family: Helvetica Neue;
      color: white;
      font-style: normal;
      font-size: 52px;
      line-height: 80px;
      /* or 154% */

      text-align: center;
      margin: 0px;
    }
    .company-title {
      font-weight: 300;
    }
  }
  .cta {
    margin-top: 200px;
    padding: 0px 2.5vw;
    p {
      font-size: 24px;
      line-height: 47px;
      color: #545454;
    }
  }

  .device-container {
    flex: 1;
    text-align: center;
    margin-top: 20px;
    img {
      width: 260px;
    }
  }
}
.line {
  margin-top: 170px;
  width: 95vw;
}
.button-container {
  align-items: flex-start;
  display: flex;

  a {
    display: block;
    width: 150px;
    padding: 10px 0;
    border: 2px solid #3ec19d;
    background: #3ec19d;
    border-radius: 2px;
    text-decoration: none;
    font-size: 16px;
    color: #fff;
    text-align: center;
    font-weight: 600;

    img {
      position: relative;
      top: 2.5px;
      margin-left: 7px;
    }
  }
}
.who {
  h2 {
    font-size: 45px;
    font-weight: 400;
    margin: 0px;
  }
  p {
    margin: 20px 0px;
    max-width: none;
    font-size: 18px;
  }
}
.logo-banner-container {
  padding: 10px;
  margin-bottom: 40px;
}
@media (max-width: 768px) {
  .jumbotron {
    height: 400px;
    margin-top: 0px;
    flex-direction: column;
    .title {
      margin-top: 0px;
      h1 {
        font-size: 32px;
        line-height: 50px;
      }
    }
    .device-container-mobile {
      display: flex;
      justify-content: center;
      img {
        width: 150px;
      }
    }
    .cta {
      margin-top: 0px;
      p {
        font-size: 16px;
        line-height: 35px;
      }
    }
  }
  .line {
    margin-top: 260px;
  }
  .device-container {
    display: none;
  }
  .who {
    h2 {
      font-size: 28px;
    }
    p {
      font-size: 16px;
    }
  }
}
</style>
